import axios from "axios";
window.axios = axios;

// Configure for Sanctum cookie-based CSRF
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.withCredentials = true;

// Use Sanctum's cookie-based CSRF instead of meta tag
window.axios.defaults.xsrfCookieName = "XSRF-TOKEN";
window.axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";

// Remove the meta tag CSRF token setup completely
// Comment out or remove these lines:
// const token = document.head.querySelector('meta[name="csrf-token"]');
// if (token) {
//     window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
// } else {
//     console.error('CSRF token not found');
// }
